<template>
  <div class="header" :class="headerClasses">
    <div v-if="!isMobile" class="btn-element-tooltip">
      <SelectBusiness />
    </div>

    <div class="header__content">
      <!--      TODO: Hidden - reveal the commented out code when is ready-->
      <!--      <my-button v-if="!isMobile" class="btn_green">-->
      <!--        <svg class="icon ic-shift" width="17" height="17" fill-rule="evenodd">-->
      <!--          <use xlink:href="@/assets/sprites/sprite.svg#ic-shift"></use>-->
      <!--        </svg>-->
      <!--        {{ trans('Start shift') }}-->
      <!--      </my-button>-->

      <header-auth v-if="!isMobile" />

      <div class="header-action">
        <!--      TODO: Hidden - reveal the commented out code when is ready-->

        <!--        <div v-if="!isMobile" class="header-action__item">-->
        <!--          <svg class="icon ic-msg" width="24" height="24">-->
        <!--            <use xlink:href="@/assets/sprites/sprite.svg#ic-msg"></use>-->
        <!--          </svg>-->
        <!--        </div>-->

        <div v-if="isMobile" class="header-action__item-menu" @click.stop="toggleMobileSideBar">
          <svg class="icon ic-menu-lines" width="18" height="21">
            <use xlink:href="@/assets/sprites/sprite.svg#ic-menu-lines"></use>
          </svg>
        </div>

        <div class="header-action__item" @click.stop="toggleNotifications">
          <svg class="icon ic-notice" width="24" height="24">
            <use xlink:href="@/assets/sprites/sprite.svg#ic-notice"></use>
          </svg>
          <div v-if="notificationCount > 0" class="notice-item__circle"></div>
        </div>
      </div>
    </div>
  </div>

  <Transition name="fade">
    <div v-show="isAnyModalOpen" class="site-shadow" @click="handleClose"></div>
  </Transition>
  <MobileSidebar
    v-if="isMobile"
    :is-open="openMobileSideBar"
    @close="openMobileSideBar = false"
  />
  <Notifications v-show="openNotice" :open-notice="openNotice" @close="toggleNotifications" />
</template>

<script setup lang="ts" inheritAttrs="false">
import { computed, ref, watch, useAttrs } from 'vue';
import SelectBusiness from '@/components/Header/SelectBusiness.vue';
import HeaderAuth from '@/components/Header/HeaderAuth.vue';
import MobileSidebar from '@/mobile_components/Mob_SideBar.vue';
import Notifications from '@/components/Notifications/Notifications.vue';
import { useNotificationStore } from '@/store/notification';
import { useUIStore } from '@/store/ui';

const uiStore = useUIStore();
const attrs = useAttrs();
const openNotice = ref(false);
const openMobileSideBar = ref(false);

// Sync local state with UI store
watch(
  () => uiStore.isMobileSideBarOpen,
  (newValue) => {
    openMobileSideBar.value = newValue;
  },
  { immediate: true }
);

// Close sidebar when switching from mobile to desktop view
watch(
  () => uiStore.isMobile,
  (isMobile) => {
    if (!isMobile && openMobileSideBar.value) {
      uiStore.toggleMobileSideBar(false);
    }
  }
);

const notificationCount = computed(() => useNotificationStore().unreadCount);
const isMobile = computed(() => uiStore.isMobile);
const isAnyModalOpen = computed(() => {
  return openNotice.value && !isMobile.value && openMobileSideBar.value;
});

// Handle class binding from parent
const headerClasses = computed(() => {
  const classes = ['header'];
  const classAttr = attrs.class as any;
  
  if (typeof classAttr === 'string') {
    classes.push(classAttr);
  } else if (Array.isArray(classAttr)) {
    classes.push(...classAttr);
  } else if (typeof classAttr === 'object' && classAttr) {
    Object.keys(classAttr).forEach(key => {
      if (classAttr[key]) {
        classes.push(key);
      }
    });
  }
  
  return classes;
});

const toggleNotifications = () => {
  openNotice.value = !openNotice.value;
  if (openNotice.value) {
    uiStore.toggleMobileSideBar(false);
  }
};

const toggleMobileSideBar = () => {
  const newState = !openMobileSideBar.value;
  uiStore.toggleMobileSideBar(newState);
  if (newState) {
    openNotice.value = false;
  }
};

function handleClose() {
  if (openNotice.value) {
    toggleNotifications();
  }
  if (openMobileSideBar.value) {
    uiStore.toggleMobileSideBar(false);
  }
}
</script>

<style lang="scss">
@use '@/assets/styles/header-page.scss';

</style>
